import React, { useState, startTransition, useEffect } from 'react';

import { lazyWithPreload } from '../utilities/lazy-with-preload';
import MODAL_COMPONENTS from '../components/common/modals/ModalComponents';
import { useAppContext, ModalContext } from '../context';
import { useTracking } from '../data/gtm';

const BasicModal = lazyWithPreload(
    () => import(/* webpackChunkName: 'BasicModal'  */ '../components/common/BasicModal')
);

export const ModalProvider = ({ children }) => {
    const [modal, setModal] = useState({ type: null, props: {} });

    const { pushEvent } = useTracking();


    const { isHandheldDevice } = useAppContext();

    const openModal = (type, props = {}) => {
        pushEvent(`modal_${type}_open`);
        // startTransition(() => setModal({ type, props }));
        setModal({ type, props });
    };

    const closeModal = () => {
        pushEvent(`modal_close`);
        setModal({ type: null, props: {} });
    };

    useEffect(() => {
        BasicModal.preload();
    }, []);

    const renderModal = () => {
        if (!modal.type) {
            return null;
        }

        const ModalComponent = MODAL_COMPONENTS[modal.type];
        if (!ModalComponent) {
            return null;
        }

        return (
            <ModalComponent
                {...modal.props}
                boxStyle={{
                    width: isHandheldDevice ? '90%' : 450,
                    minWidth: isHandheldDevice ? '' : 'min-content',
                    minHeight: 180,
                }}
                onClose={modal.props.onClose || closeModal}
            />
        );
    };

    return (
        <ModalContext.Provider value={{ modal, openModal, closeModal }}>
            {children} {renderModal()}
        </ModalContext.Provider>
    );
};
